import React from "react";
import PropTypes from 'prop-types';
import { Alert, Button, FormGroup, Input } from "reactstrap";
import { connect } from 'react-redux';
import { loginUser } from '../redux/actions/authActions';
import medieteticLogo from 'assets/img/medietetic-logo.svg';
import loginBackground from 'assets/img/background.png';

class LoginForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            loginFailed: false,
            usernameValid: false,
            usernameValidationMessage: '',
            passwordValid: false,
            passwordValidationMessage: '',
            error: undefined
        };
        this.login = this.login.bind(this);
    }

    handleChange = input => e => {
        this.setState({ [input]: e.target.value });
    }

    validUsername(username) {
        if (username === undefined || username.length === 0) {
            return "Korisničko ime je obavezno";
        }
        return "";
    }

    validPassword(password) {
        if (password === undefined || password.length === 0) {
            return "Lozinka je obavezna";
        }
        return "";
    }

    validateLoginForm() {
        let { usernameValid, usernameValidationMessage, passwordValid, passwordValidationMessage } = this.state;

        usernameValidationMessage = this.validUsername(this.state.username);
        usernameValid = usernameValidationMessage.length > 0 ? false : true;

        passwordValidationMessage = this.validPassword(this.state.password);
        passwordValid = passwordValidationMessage.length > 0 ? false : true;

        this.setState({
            error: undefined,
            usernameValid: usernameValid,
            usernameValidationMessage: usernameValidationMessage,
            passwordValid: passwordValid,
            passwordValidationMessage: passwordValidationMessage,
        });
        if (!usernameValid || !passwordValid) {
            return false;
        }
        return true;
    }

    login = (e) => {
        e.preventDefault();
        if (!this.validateLoginForm()) {
            return;
        }
        const userData = {
            username: this.state.username,
            password: this.state.password
        };
        this.props.loginUser(userData, this.props.history);
    }

    render() {
        const { usernameValid, usernameValidationMessage, passwordValid, passwordValidationMessage } = this.state;
        const { loginError } = this.props.auth;

        return (
            <div className="login-page">
                <div className="login-card">
                    <div className="login-card-form">
                        <img
                            src={medieteticLogo}
                            alt="MeDietetic"
                            className="login-logo"
                        />
                        <h1 className="login-title">Dobro došli!</h1>
                        <p className="login-subtitle">
                            Za prijavu unesite svoje korisničko ime i lozinku.
                        </p>
                        {loginError && (
                            <Alert color="warning" className="login-alert">
                                {loginError.message}
                            </Alert>
                        )}
                        <form noValidate onSubmit={this.login} className="login-form" autoComplete="off">
                            <FormGroup
                                className={
                                    usernameValidationMessage.length > 0
                                        ? "form-input-error-displayed login-field login-field-username"
                                        : "form-input-error-not-displayed login-field login-field-username"
                                }
                            >
                                <label htmlFor="username" className="login-label">
                                    Korisničko ime
                                </label>
                                <Input
                                    className="login-input"
                                    type="text"
                                    name="username"
                                    id="username"
                                    placeholder="Unesi korisničko ime"
                                    value={this.state.username || ''}
                                    onChange={this.handleChange('username')}
                                    autoComplete="off"
                                    spellCheck={false}
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                />
                            </FormGroup>
                            {!usernameValid && (
                                <span className="form-input-error">{usernameValidationMessage}</span>
                            )}
                            <FormGroup
                                className={
                                    passwordValidationMessage.length > 0
                                        ? "form-input-error-displayed login-field login-field-password"
                                        : "form-input-error-not-displayed login-field login-field-password"
                                }
                            >
                                <label htmlFor="password" className="login-label">
                                    Lozinka
                                </label>
                                <Input
                                    className="login-input"
                                    type="password"
                                    name="password"
                                    id="password"
                                    placeholder="Unesi lozinku"
                                    value={this.state.password || ''}
                                    onChange={this.handleChange('password')}
                                    autoComplete="off"
                                    spellCheck={false}
                                    autoCorrect="off"
                                />
                            </FormGroup>
                            {!passwordValid && (
                                <span className="form-input-error">{passwordValidationMessage}</span>
                            )}
                            <Button className="login-submit-btn" type="submit">
                                Prijavi se
                            </Button>
                        </form>
                    </div>
                    <div className="login-card-visual">
                        <img src={loginBackground} alt="" className="login-background-image" />
                    </div>
                </div>
            </div>
        );
    }
}

LoginForm.propTypes = {
    loginUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    UI: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    UI: state.UI
});

const mapActionsToProps = {
    loginUser
}

export default connect(mapStateToProps, mapActionsToProps)(LoginForm);
